import MeasurementColorModal from '@components/Viewer/Measurement/MeasurementColorModal';
import InspectionDetailModal from '@components/Viewer/UserInterface/InspectionDetail/InspectionDetail';
import { type FC } from 'react';

const ModalManager: FC = () => (
  <>
    <InspectionDetailModal />
    <MeasurementColorModal />
  </>
);

export default ModalManager;
